import { render, staticRenderFns } from "./ItemsSelection.vue?vue&type=template&id=48296a80&"
import script from "./ItemsSelection.vue?vue&type=script&lang=js&"
export * from "./ItemsSelection.vue?vue&type=script&lang=js&"
import style0 from "./ItemsSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports